module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.supportmeasures.red-fbc3a9cd62dec9a4526baeca3eaf2162.svg";